/* global globals */
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import DailyPollStore from '../stores/DailyPollStore';

const { ActionTypes } = Constants;

module.exports = {
  submitForm(fromPreview) {
    if (fromPreview) {
      AppDispatcher.dispatch({
        type: ActionTypes.DAILY_POLL_SUBMIT_SUCCESS,
      });
      return;
    }

    const formData = new FormData();

    const answers = DailyPollStore.getFormData();
    Object.keys(answers).forEach((id) => {
      formData.append('poll_id', id);
      formData.append('answer', answers[id]);
    });

    fetch(`${get(globals, 'apiWebroot', '/')}daily_polls/submit_answer`, {
      method: 'post',
      credentials: 'include',
      body: formData,
    }).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.DAILY_POLL_SUBMIT_SUCCESS,
        });
      } else {
        console.log(data);
        AppDispatcher.dispatch({
          type: ActionTypes.DAILY_POLL_SUBMIT_ERROR,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.DAILY_POLL_SUBMIT_ERROR,
      });
    });
  },
  loadDailyPoll(targetPollId) {
    let url = `${get(globals, 'apiWebroot', '/')}daily_polls/get_current`;
    if (targetPollId) {
      url += `/${targetPollId}`;
    }

    fetch(url).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.DAILY_POLL_LOAD_SUCCESS,
          poll: data.poll || null,
        });
      } else {
        console.log(data);
      }
    }).catch((data) => {
      console.log(data);
    });
  },
  closePoll(pollId, fromPreview) {
    if (fromPreview) {
      return;
    }

    fetch(`${get(globals, 'apiWebroot', '/')}daily_polls/close_poll/${pollId}`);
  },
};
